import React from "react";
import { Card, makeStyles, tokens } from "@fluentui/react-components";

const useStyle = makeStyles({
  brandTitle: {
    color: "#858585",
    fontSize: "1.2rem",
    fontWeight: tokens.fontWeightSemibold,
  },
  brandContent: {
    color: "#858585",
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400,
  },
  copyright: {
    color: "#858585",
    fontSize: tokens.fontSizeBase200,
  },
  policy: {
    color: "#858585",
    fontSize: tokens.fontSizeBase200,
  },
});

/**
 * The `FooterCard` component renders a card with branding information for a company called QR Mark.
 * @returns A FooterCard component is being returned, which renders a Card component with three spans
 * inside it. The spans have classNames assigned using the style object returned from the useStyle
 * hook.
 */
const FooterCard = () => {
  const style = useStyle();
  const currentYear = new Date().getFullYear();

  return (
    <Card>
      <span className={style.brandTitle}>QR Mark</span>
      <span className={style.brandContent}>Securing document made easy</span>
      <p className={style.policy}>
        <a
          href="https://qrmark.com/terms-of-service"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none", color: "#858585" }}
        >
          Terms of Service
        </a>
        <span style={{ paddingLeft: "0.5rem", paddingRight: "0.5rem", color: "#858585" }}>|</span>
        <a
          href="https://qrmark.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none", color: "#858585" }}
        >
          Privacy Policy
        </a>
      </p>
      <span className={style.copyright}> &copy; {currentYear} QR Mark. All right reserved.</span>
    </Card>
  );
};

export default FooterCard;
